import TourGamesAdmin from './TourGamesAdmin';
export default TourGamesAdmin;
